import { DrawerProps as AntDrawerProps, Drawer, Space } from 'antd';
import { useHooryWidgetHiderCount } from 'hooks/third-party/useHooryWidget';
import { useHandleCloseModalOrDrawer } from 'hooks/useHandleCloseModalOrDrawer';
import { usePageNoScroll } from 'hooks/usePageNoScroll';
import { Close } from 'icons/Close';

export const DrawerPage = ({
  open,
  bodyStyle,
  children,
  ...delegated
}: AntDrawerProps) => {
  usePageNoScroll(open);
  useHooryWidgetHiderCount({ hiderType: 'drawer', open });

  const handleCloseDrawer = useHandleCloseModalOrDrawer();

  return (
    <Drawer
      push={false}
      headerStyle={{
        top: 24,
        left: 0,
        zIndex: 1,
        background: 'transparent',
        padding: '20px 20px 0 18px',
        border: 'none',
        marginLeft: 'auto',
        marginRight: 0
      }}
      closeIcon={
        <Space
          style={{
            background: 'var(--v3-black-1)',
            width: '40px',
            height: 40,
            fontSize: 28,
            justifyContent: 'center',
            borderRadius: '80px'
          }}
        >
          <Close />
        </Space>
      }
      height="100%"
      destroyOnClose
      open={open}
      placement="bottom"
      bodyStyle={{ overflow: 'hidden', padding: 0, ...bodyStyle }}
      onClose={handleCloseDrawer}
      {...delegated}
    >
      {children}
    </Drawer>
  );
};
